<template>
  <component-tip :content="content">
    <date-picker v-bind="$attrs" v-on="$listeners" />
  </component-tip>
</template>

<script>
import DatePicker from '@/components/select/date-picker/date-picker.vue'
import ComponentTip from './component-tip'

export default {
  components: {
    ComponentTip,
    DatePicker
  },
  props: {
    // eslint-disable-next-line
    content: {}
  }
}
</script>
